// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"351":"commons","678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] || chunkId) + "-" + {"351":"cc5ed1b3b65fa44f95a9","678":"1e5e1b3e037f1709e98d","731":"56651bc0b12319a96cbf","843":"1b496c9b9487684929be","883":"da3c024a37b3bae368b4"}[chunkId] + ".js";
};